import axiosImpl from '@/services/axios/axiosImpl'
import axiosAuthImpl from '@/services/axios/axiosAuthImpl'
import axiosLoginImpl from '@/services/axios/axiosLoginImpl'

import { EventBus } from "@/EventBus";
import { faGrinTongueSquint } from '@fortawesome/free-solid-svg-icons';

export default class HttpBase {
    constructor(path, typoAxios) {
        if (typoAxios === 1) {
            this.axios = axiosAuthImpl;
        } else if (typoAxios === 2) {
            this.axios = axiosImpl;
        }if (typoAxios === 3) {
            this.axios = axiosLoginImpl;
        }
        this.path = path;
    }

    async get(url = '') {
        return await this.axios.get(this.path + url, { data: {} }).then(this.then).catch(this.error)
    }

    put(url, data) {
        return this.axios.put(this.path + url, data).then(this.then).catch(this.error)
    }

    post(url, data) {       
        return this.axios.post(this.path + url, data).then(this.then).catch(this.error)
    }

    patch(url, data) {
        return this.axios.patch(this.path + url, data).then(this.then).catch(this.error)
    }

    delete(url = '') {
        return this.axios.delete(this.path + url).then(this.then).catch(this.error)
    }

    then(response) {
        EventBus.$emit('UNLOADING')
        if (!response.data) {
            return;
        }
        try {
            return JSON.parse(response.data)
        } catch (error) {
        }
        return response.data
    }

    isNullOrEmpty(value) {
        return value == null || value === "";
    }
}